module.exports = __webpack_public_path__ + "static/img/12312.b5830afb.png";